<template lang="pug">
  b-form(@submit.stop.prevent="onSubmit")
    .box-form
      .material-icons.icon-input perm_identity
      b-form-group(
        invalid-feedback="Este campo es requerido"
        label="Nombre"
      )
        b-form-input(
          v-model="form.name"
          maxlength="256"
          :state="$v.$dirty ? !$v.form.name.$invalid : null"
        )
    .box-form
      .material-icons.icon-input perm_identity
      b-form-group(
        label="Apellidos"
        invalid-feedback="Este campo es requerido"
      )
        b-form-input(
          v-model="form.lastName"
          maxlength="256"
          :state="$v.$dirty ? !$v.form.lastName.$invalid : null"
        )
    .box-form(v-if="this.defaultValues.role !== 'store'")
      .material-icons.icon-input assignment_ind
      b-form-group(
        label="Rol"
        invalid-feedback="Este campo es requerido"
      )
        b-form-select(
          v-model="form.role"
          :options="accountOptions"
          @change="handleSelectChange"
          :state="$v.$dirty ? !$v.form.role.$invalid : null"
      )
    div(v-if="typeDriver")
      .box-form
        .material-icons.icon-input keyboard
        b-form-group(
          label="Código Conductor"
          invalid-feedback="Este campo es requerido"
        )
          b-form-input(
            v-model="form.codeDriver"
            maxlength="20"
            @input="onCodeDriverInput"
            :state="$v.$dirty ? !$v.form.codeDriver.$invalid : null"
          )
        b-form-invalid-feedback(v-if="codeDriverError" class="error-message")
          | {{ codeDriverError }}
      div.mt-0.mb-2(style="margin-left: 35px")
        b-checkbox(v-model="form.canReceivePackages") Puede pistolear en tienda y en ruta
        b-checkbox.pt-3.pb-1(v-model="form.canReceivedInWarehouse") Puede recepcionar paquetes en bodega
    .box-form
      .material-icons.icon-input mail_outline
      b-form-group(
        label="Email"
        invalid-feedback="Este campo es requerido"
      )
        b-form-input(
          v-model="form.email"
          maxlength="256"
          :state="$v.$dirty ? !$v.form.email.$invalid : null"
        )
    .box-form
      .material-icons.icon-input home
      b-form-group(
        label="Dirección"
        invalid-feedback="Este campo es requerido"
      )
        b-form-input(
          v-model="form.address"
          maxlength="256"
        )
    .box-form
      .material-icons.icon-input home
      b-form-group(
        label="Comuna"
        invalid-feedback="Este campo es requerido"
      )
        b-form-input(
          v-model="form.commune"
          maxlength="256"
        )
    .box-form
      .material-icons.icon-input phone
      b-form-group(
        label="Teléfono"
      )
        b-input-group(
          prepend="+56"
        )
          b-form-input(
            id="phone-input"
            autocomplete="off"
            v-model="form.phone"
            maxlength="256"
            aria-describedby="phone-input-feedback"
            :state="$v.$dirty ? !$v.form.phone.$invalid : null"
          )
          b-form-invalid-feedback(id="phone-input-feedback")
            | {{ getInvalidFeedback($v.form.phone) }}
    .box-form(v-if="!defaultValues.role")
      .material-icons.icon-input manage_accounts
      b-form-group(
        v-if="!defaultValues.role"
        label-for="role-input"
        invalid-feedback="Este campo es requerido"
      )
        .input-title Rol
        b-form-select#role-input.input(
          v-model="form.role"
          :options="roleOptions"
          :state="$v.$dirty ? !$v.form.role.$invalid : null"
        )
    .box-form
      .material-icons.icon-input lock
      b-form-group(
        :label="`Contraseña${ editMode ? ' (opcional)' : '' }`"
        label-for="password-input"
        invalid-feedback="Este campo es requerido"
      )
        b-form-input#password-input.input(
          v-model="form.password"
          maxlength="256"
          type="password"
          :state="$v.$dirty ? !$v.form.password.$invalid : null"
        )
    .box-form
      .material-icons.icon-input lock
      b-form-group(
        label="Repetir contraseña"
        label-for="repeat-password-input"
        invalid-feedback="Las contraseñas no coinciden"
      )
        b-form-input#repeat-password-input.input(
          v-model="form.repeatPassword"
          type="password"
          :state="$v.$dirty ? !$v.form.repeatPassword.$invalid : null"
        )
    b-checkbox(v-model="form.active") Activo
    .text-right
      b-button(type="submit" :disabled="statusSubmit")  Guardar
</template>

<script>
import roles from '../../common/roles'
import { isDriverRole } from '../../constants/userRoles'
import { required, email, sameAs } from 'vuelidate/lib/validators'
import { validPhoneNumber, getInvalidFeedback } from '@/utils/customValidations.js'
import { mapActions } from 'vuex'
import MakeToastMixin from '../mixins/MakeToastMixin'

export default {
  mixins: [MakeToastMixin],
  props: {
    user: {
      type: Object,
      default: null
    },
    editMode: Boolean,
    defaultValues: {
      type: Object,
      default: () => { return {} }
    }
  },
  data() {
    return {
      getInvalidFeedback,
      form: {
        name: this.editMode ? this.user.name : '',
        lastName: this.editMode ? this.user.lastName : '',
        active: this.editMode ? this.user.active : true,
        email: this.editMode ? this.user.email : '',
        role: this.defaultValues.role ? this.defaultValues.role : (this.editMode ? this.user.role : roles[0].value),
        password: '',
        repeatPassword: '',
        storeId: this.defaultValues.storeId ? this.defaultValues.storeId : (this.editMode ? this.user.storeId : null),
        account: '',
        codeDriver: this.editMode ? this.user.codeDriver : '',
        canReceivePackages: this.editMode ? this.user.canReceivePackages : false,
        canReceivedInWarehouse: this.editMode ? this.user.canReceivedInWarehouse : false,
        address: this.editMode ? this.user.address : '',
        commune: this.editMode ? this.user.commune : '',
        phone: this.editMode ? this.user.phone : ''
      },
      accountOptions: [
        { value: null, text: 'Seleccione', disabled: true, selected: true },
        { value: 'admin', text: 'Dueño' },
        { value: 'driver', text: 'Conductor' },
        { value: 'viewer', text: 'Visualizador' },
        { value: 'warehouse', text: 'Recepción bodega' }
      ],
      roles: roles,
      typeDriver: false,
      statusSubmit: false,
      codeDriverError: ''
    }
  },
  validations() {
    const form = {
      name: { required },
      lastName: { required },
      email: { required, email },
      role: { required },
      password: {},
      codeDriver: this.typeDriver ? { required } : {},
      phone: { validPhoneNumber },
      repeatPassword: { sameAs: sameAs('password') }
    }
    if (!this.editMode) {
      form.password = { required }
    }
    return { form }
  },
  mounted() {
    if (this.editMode) {
      this.form.role = this.user.role
      if (isDriverRole(this.form.role)) {
        this.form.codeDriver = this.user.codeDriver
        this.typeDriver = true
      }
    }
  },
  methods: {
    ...mapActions(['createUser', 'updateUser', 'validateCodeDriver']),
    onSubmit() {
      if (this.$v.$invalid) {
        this.$v.$touch()
      } else {
        if (this.editMode) {
          this.onUpdateUser()
        } else {
          this.onCreateUser()
        }
      }
    },
    handleSelectChange() {
      this.codeDriverError = ''
      if (isDriverRole(this.form.role)) {
        this.typeDriver = true
      } else {
        this.typeDriver = false
        this.form.codeDriver = ''
      }
    },
    async onCodeDriverInput() {
      const codeDriver = this.form.codeDriver
      // console.log(codeDriver, 'CodeDriver')
      if (codeDriver.length >= 3) {
        if (codeDriver.toUpperCase() === this.user?.codeDriver?.toUpperCase() && this.editMode) {
          return
        }
        const response = await this.validateCodeDriver({ params: { validateCode: codeDriver } })
        if (response.codeFind === 0) {
          this.codeDriverError = ''
          this.statusSubmit = false
        } else {
          this.codeDriverError = 'El código del conductor ya existe'
          this.statusSubmit = true
        }
      }
    },
    async onCreateUser() {
      this.statusSubmit = true
      const data = this.form
      if (!isDriverRole(this.form.role)) {
        data.codeDriver = null
      }
      const response = await this.createUser({ data })
      if (response.status === 201) {
        this.makeSuccessToast('El usuario se creó correctamente')
        this.$emit('done')
      } else if (response.status >= 400) {
        this.makeDangerToast(response.data.message || 'Error al crear el usuario')
      }
      this.statusSubmit = false
    },
    async onUpdateUser() {
      const data = { ...this.form }
      if (data.password === '') {
        delete data.password
      }
      const response = await this.updateUser({ id: this.user.id, data })
      if (response.status === 200) {
        this.makeSuccessToast('El usuario se editó correctamente')
        this.$emit('done')
      } else if (response.status >= 400) {
        this.makeDangerToast(response.data.message || 'Error al editar el usuario')
      }
    }
  },
  computed: {
    roleOptions() {
      // retrona los roles de admin y delivery de la lista de roles
      return roles.reduce((acum, role) => ['admin', 'delivery'].includes(role.value) ? acum.concat(role) : acum, [])
    }
  }
}
</script>
